import { render } from "./SlideBlock.vue?vue&type=template&id=392a4be6&scoped=true"
import script from "./SlideBlock.vue?vue&type=script&lang=js"
export * from "./SlideBlock.vue?vue&type=script&lang=js"

import "./SlideBlock.vue?vue&type=style&index=0&id=392a4be6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-392a4be6"]])

export default __exports__